import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import RequestServies from "../../../services/RequestServies";
import ProductServices from "../../../services/ProductServices";
import RequisitionForm from "../Requisition/RequisitionNumberModal";
import Swal from 'sweetalert2'; // Import SweetAlert

const DieselOrders = ({ onSuccess }) => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState();

  const user = JSON.parse(localStorage.getItem("userDetails"));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || "";

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  const [requisition, setRequisiton] = useState('');
  const [selectedRequisition, setSelectedRequisiton] = useState('');

  const [mrv,setMrv]=useState([])
  const [selectedMrv, setSelectedMrv] = useState([])
  const [run, setRun] = useState(0);

  const [items, setItems] = useState([
    { name: "", id: "",description:"", approveQty: 0, qtyRequired: 0 ,recivedQty: 0,damageQty:0,error:"" },
  ]);
  const [partOptions, setPartOptions] = useState([]);
  const [item, setItem] = useState();

 

  const handleItemChange = (index, field, value) => {
    // Convert value to number if it's for recivedQty or damageQty
    const numericValue = (field === "recivedQty" || field === "damageQty") ? parseFloat(value) : value;

    const newItems = [...items];
    newItems[index][field] = numericValue;

    if (field === "recivedQty") {
        if (numericValue > (newItems[index].approveQty - newItems[index].damageQty)) {
            newItems[index].error = `Recived Qty cannot be greater than Approve Qty`;
        } else if (numericValue < 0) {
            newItems[index].error = `Recived Qty cannot be 0 or negative`;
        } else {
            newItems[index].error = "";
        }
    }

    if (field === "damageQty") {
        if (numericValue > newItems[index].approveQty - newItems[index].recivedQty) {
            newItems[index].error = `Damage Qty cannot be greater than Approve Qty`;
        } else if (numericValue < 0) {
            newItems[index].error = `Damage Qty cannot be 0 or negative`;
        } else {
            newItems[index].error = "";
        }
    }
    
    setItems(newItems);
};

  const handlePartSelect = (index, selectedOption) => {
    const isDuplicate = items.some(item => item.id === selectedOption.value);

    if (isDuplicate) {
        Swal.fire({
            icon: 'error',
            title: 'Duplicate Item',
            text: 'This item has already been added to the requisition.',
            confirmButtonText: 'OK'
        });
        return; // Exit the function if a duplicate is found
    }
    
    handleItemChange(index, "id", selectedOption.value);
    handleItemChange(index, "name", selectedOption.label);
    handleItemChange(index, "approveQty", selectedOption.approveQty);
    handleItemChange(index, "qtyRequired", selectedOption.qtyRequired);
    handleItemChange(index, "description", selectedOption.description); // Set description
   
  };
  
 

  useEffect(() => {
    // Fetch parts options for the dropdown
    const status = 'approved'
    RequestServies.getDesileItem(status,selectedStore) // Assume this service returns a list of parts
      .then((res) => {
        const options = res.data.data.map((part) => ({
          value: part._id,
          label: part.inventory.masterItem.partNo,
          approveQty: part.approveQty,
          description:part?.inventory?.masterItem?.description,
          qtyRequired: part.qtyRequired,
          
        }));
        setPartOptions(options);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedStore,selectedRequisition,run]);

  const handleSubmit = (e) => {

    e.preventDefault();

    let isValid = true;
    let errorMessage = "";

    items.forEach((item, index) => {
      if (item.recivedQty > item.approveQty - item.damageQty) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be greater than eligible Qty`;
      } else if (item.recivedQty < 0) {
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
      }else if(item.damageQty > item.approveQty-item.recivedQty){
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be greater than eligible Qty`;
     
      }else if(item.damageQty< 0){
        isValid = false;
        errorMessage = `Item ${index + 1}: Required Qty cannot be 0 or negative`;
     
      }
    });

    if (!isValid) {
      alert(errorMessage);
      return;
    }


    const requestData = { items };

    RequestServies.submitDesile(requestData)
      .then((response) => {
        console.log('Submission successful:', response);
        alert('Submission  successful');
        setItems([
          { name: "", id: "",description:"", approveQty: 0, qtyRequired: 0 ,recivedQty: 0,damageQty:0,error:"" },
        ])
        setRun(run + 1)

      })
      .catch((error) => {
        console.log('Error during submission:', error);
        alert('Error during submission');
        // Handle error feedback here
      });

  };

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    setSelectedMrv();
  };

  const handleRequsitionChange = (e) => {
    setSelectedRequisiton(e.target.value);
  };
  const handleRequisitionForm = (item) => {
    setIsModelOpen(true);
  };

  const handleMrv = (e) =>{
    setSelectedMrv(e.target.value)
  }
  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row justify-content-center">
                    <div className="col-xl-6 col-xxl-6">
                      <label className="d-block text-center">Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {store.name}
                          </option>
                        ))}
                      </select>
                    </div>
                                        
                    

                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-plus me-2" aria-hidden="true"></i>Add
                MRV Item
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <form>
                        {items.map((item, index) => (
                          <div key={index} className="row">
                            <div className="form-group mb-2 col-md-2">
                              <label>Part Number</label>
                              <Select
                                options={partOptions}
                                onChange={(selectedOption) =>
                                  handlePartSelect(index, selectedOption)
                                }
                                placeholder="Part"
                                menuPortalTarget={document.body}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minWidth:90, // increase width (adjust as needed)
                                    height:14, // increase height (adjust as needed)
                                    fontSize: '12px', // change font size (optional)
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    height: '100%', // ensures the value container aligns with the control height
                                  }),
                                  input: (base) => ({
                                    ...base,
                                    height: 'auto', // allows the input to grow with the control's height
                                  }),
                                }}
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="description"
                                value={item.description}
                                placeholder="Description"
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Approved</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="approveQty"
                                value={item.approveQty}
                                placeholder="approveQty"
                                readOnly
                              />
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Required Qty</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="qtyRequired"
                                value={item.qtyRequired}
                                placeholder="Required Qty"
                                readOnly
                              />
                              
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Received Qty</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="recivedQty"
                                value={item.recivedQty}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "recivedQty",
                                    event.target.value
                                  )
                                }
                                placeholder="recivedQty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                            <div className="form-group mb-2 col-md-2">
                              <label>Damage</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name="damageQty"
                                value={item.damageQty}
                                onChange={(event) =>
                                  handleItemChange(
                                    index,
                                    "damageQty",
                                    event.target.value
                                  )
                                }
                                placeholder="Damage Qty"
                              />
                              <p className="text-danger">{item.error}</p>
                            </div>
                          </div>
                        ))}
                        <div className="row">
                          

                          <div className="form-group mb-2 col-md-2">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default DieselOrders;
